(function () {
    'use strict';

    function entityDashboardController($scope, $log, $timeout, $rootScope, $location, $uibModal,
        sessionData, myProfile, dashboardFeatures, dashboardActivities, mostRecentItems,
        mostRecentItemsThumbnails, milestones, myProfileDataService,
        notifyService, milestoneModalService,
        scrollingService, mailRequestDataService, entityProfilePercentageCompleteCalculatorService,
        $pbService, STATES_LIST) {

        var vm = this;
        vm.sessionData = sessionData;
        vm.entity = myProfile;
        vm.entity.open = true;
        vm.statesList = STATES_LIST;
        vm.currentProfilePanelIndex = 0;
        vm.baseProfileCompletedPercentage = 30;
        vm.showOpportunities = true;
        vm.showSharing = true;
        vm.showSiteNameInLists = (sessionData.SiteMappings && sessionData.SiteMappings.length > 1) ||
            sessionData.IsAdminEntity;
        vm.dashboardFeatures = dashboardFeatures;
        vm.dashboardActivities = dashboardActivities.filter(function (x) {
            return x.DashboardActivityOptionType === "Workflow" || x.DashboardActivityOptionType === "Link";
        });
        vm.mostRecentItems = mostRecentItems;
        vm.mostRecentItems.forEach(function (item) {
            var matchingThumbnailObj = mostRecentItemsThumbnails[item.WorkflowId];
            if (matchingThumbnailObj && matchingThumbnailObj.Thumbnails && matchingThumbnailObj.Thumbnails.length > 0) {
                var prefix = matchingThumbnailObj.IsTemplate ? 'gettemplate' : 'getupload';
                item.ThumbnailUrl = '/files/' + prefix + '?blobreference=' + matchingThumbnailObj.Thumbnails[0] + '&fileName='+ matchingThumbnailObj.Thumbnails[0];
            }
        });
        vm.toggleCreateNewMenu = function () {
            vm.showCreateNewMenu = !vm.showCreateNewMenu;
        }

        vm.createNewPopoverUrl = 'dashboards/templates/createNew.html';

        vm.profilePanels = ['companyDetails', 'tellUs', 'attributes', 'card'];
        switch (vm.entity.ViewModelType) {
            case "AccountManager":
                vm.profilePanels.splice(vm.profilePanels.indexOf('tellUs'), 1);
                vm.profilePanels.splice(vm.profilePanels.indexOf('card'), 1);
                vm.workflowsUrl = "[BuildifyApiHost]/api/accountmanagers/workflows";
                break;
            case "InsuranceBroker":
                vm.workflowsUrl = "[BuildifyApiHost]/api/insurancebrokers/workflows";
                break;
            case "ProductProvider":
                vm.workflowsUrl = "[BuildifyApiHost]/api/productproviders/workflows";
                break;
            default:
                vm.workflowsUrl = "[BuildifyApiHost]/api/workflows";
        }

        // if (vm.entity.Attributes.length === 0) {
        //     vm.profilePanels.splice(vm.profilePanels.indexOf('attributes'), 1);
        // }

        milestoneModalService.getMilestonesAndTemplates(milestones).then(function (milestonesAndTemplates) {
            if (milestonesAndTemplates.length > 0) {
                milestoneModalService.openModal(milestonesAndTemplates);
            }
        });

        vm.progressCircleOptions = {
            color: $rootScope.$themes[$rootScope.$currentTheme].accentColor,
            duration: 1400,
            strokeWidth: 3,
            trailWidth: 3,
            easing: 'easeInOut',
            text: {
                autoStyleContainer: false,
                style: {
                    // Text color.
                    // Default: same as stroke color (options.color)
                    color: $rootScope.$themes[$rootScope.$currentTheme].primaryColor,
                    position: 'absolute',
                    left: '50%',
                    top: '50%',
                    padding: 0,
                    margin: 0,
                    // You can specify styles which will be browser prefixed
                    transform: {
                        prefix: true,
                        value: 'translate(-50%, -50%)'
                    },
                    fontSize: '20px',
                }
            }
        };

        function updateProgressBars(prefix, results) {
            for (var i = 0; i < results.length; i++) {
                $pbService.set('progressCircle-' + prefix + '-' + i, (results[i].PercentageComplete || 0) / 100);
            }
        }

        $rootScope.$on('simpleSearchResultsUpdated', function (event, args) {
            if (args.results && args.results.length > 0) {
                if (!args.results[0].PartnerId) {
                    // updateProgressBars('Workflow', args.results);
                }
                else if (args.results[0].PartnerId) {
                    // updateProgressBars('SharedWorkflow', args.results);
                }
            }
        });

        // vm.profilePanelCount = vm.profilePanels.length;
        // vm.isProfileEditorVisible = false;
        // vm.allowedLogoUploadFileExtensions = ['gif', 'jpg', 'jpeg', 'png', 'bmp', 'svg'];
        // vm.updateErrors = null;
        // vm.path = [];

        // vm.simplePublish = function () {
        //     vm.entity.IsPublished = true;
        //     mailRequestDataService.sendPublishedUpdate({ EntityId: vm.sessionData.EntityId });
        //     vm.updateMyProfile();
        //     vm.updatePublishingState();
        //     vm.openPublishingAlert();
        // }

        // vm.simpleUnpublish = function () {
        //     vm.entity.IsPublished = false;
        //     vm.updateMyProfile();
        //     vm.updatePublishingState();
        //     vm.openPublishingAlert('unpublished');
        // }

        // vm.premiumPublish = function () {
        //     if (vm.entity.IsPremiumAccount) {
        //         vm.entity.IsPublished = true;
        //         mailRequestDataService.sendPublishedUpdate({ EntityId: vm.sessionData.EntityId });
        //         vm.updateMyProfile();
        //         vm.updatePublishingState();
        //     }
        //     vm.openPublishingAlert();
        // }

        // vm.publishActions = {
        //     'Self': {
        //         call: vm.simplePublish
        //     },
        //     'SelfAndAdmin': {
        //         call: vm.simplePublish
        //     },
        //     'Premium': {
        //         call: vm.premiumPublish
        //     }
        // }

        // vm.unpublishActions = {
        //     'Self': {
        //         call: vm.simpleUnpublish
        //     },
        //     'SelfAndAdmin': {
        //         call: vm.simpleUnpublish
        //     },
        //     'Premium': {
        //         call: vm.simpleUnpublish
        //     }
        // }

        // vm.updatePublishingState = function () {
        //     vm.isEntityPublishable = !vm.entity.IsPublished && vm.publishActions.hasOwnProperty(vm.entity.PublishingType);
        //     vm.isEntityUnpublishable = vm.entity.IsPublished && vm.publishActions.hasOwnProperty(vm.entity.PublishingType);
        // }

        // vm.updatePublishingState();

        // vm.openPublishingAlert = function (state) {
        //     var modalInstance = $uibModal.open({
        //         templateUrl: 'publishEventModal',
        //         controller: 'entityPublishingModalController',
        //         resolve: {
        //             publishingState: function () {
        //                 if (state === 'unpublished') {
        //                     return 'Unpublished'
        //                 } else if (vm.entity.PublishingType === 'Premium' && !vm.entity.IsPremiumAccount) {
        //                     return 'UpgradeRequired';
        //                 }

        //                 return 'Published';
        //             },
        //             entityId: function () {
        //                 return sessionData.EntityId;
        //             }
        //         }
        //     });

        //     return modalInstance.result.then(function () { });
        // }

        // $scope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
        //     vm.path = toParams.path;
        //     switch (toState.name) {
        //         case ("dashboard"):
        //             vm.isProfileEditorVisible = false;
        //             break;
        //         case ("dashboard.myprofile"):
        //             vm.isProfileEditorVisible = true;
        //             $timeout(function () {
        //                 scrollingService.scrollTo('profileEditorForm', 0, 0, 0);
        //             });
        //             break;
        //     }
        // });

        // vm.calculateProfileCompletedPercentage = function () {
        //     vm.profileCompletedPercentage = entityProfilePercentageCompleteCalculatorService.calculateProfileCompletedPercentage(vm.entity, vm.baseProfileCompletedPercentage);

        //     if (vm.profileCompletedPercentage === 100) {
        //         vm.profilePanelCount = 4;
        //     }
        // }

        // vm.calculateProfileCompletedPercentage();

        // vm.modelOptions = {
        //     updateOn: 'default blur',
        //     debounce: {
        //         "default": 300,
        //         "blur": 0
        //     }
        // };

        // if (vm.sessionData.SiteFeatures.HasProfile) {
        //     $timeout(function() {
        //         vm.myProfileForm = $scope.myProfileForm;
        //         $scope.$watch(
        //             function() {
        //                 return {
        //                     dirty: vm.myProfileForm.$dirty,
        //                     valid: vm.myProfileForm.$valid
        //                 }
        //             },
        //             function(newVal) {
        //                 if (newVal.valid && newVal.dirty) {
        //                     // TODO: Hack to hangle checkbox-list not working with ng-modeloptions
        //                     $timeout(function() {
        //                         vm.updateMyProfile();
        //                     }, 0);
        //                 }
        //             },
        //             true);
        //     }, 0);
        // }

        // vm.change = function () {
        //     $log.debug('checklist changed');
        // }

        // $rootScope.$on('fileUploaded', function (event, args) {
        //     vm.entity.Logo = args.blobs[0];
        //     vm.updateMyProfile();
        // });

        // vm.updateMyProfile = function () {
        //     if ($scope.myProfileForm.$valid) {
        //         vm.updateErrors = null;

        //         return myProfileDataService.updateMyProfile(angular.toJson(vm.entity)).then(
        //             function (response) {
        //                 //notifyService.notify('Updated profile');
        //                 vm.calculateProfileCompletedPercentage();
        //                 $scope.myProfileForm.$setPristine();
        //             },
        //             function (errorResponse) {
        //                 self.updateErrors = errorResponse.data;
        //             });
        //     }
        //     else {
        //         self.errors = 'Form errors';
        //         return false;
        //     }
        // };

        // vm.tinymceOptions = {
        //     height: "300",
        //     menubar: false,
        //     statusbar: false,
        //     resize: false,
        //     plugins: [
        //         "advlist autolink link paste"
        //     ],
        //     advlist_bullet_styles: "disc",
        //     toolbar: "undo redo | bold italic | bullist | link",
        //     valid_elements: '*[*]',
        //     debounce: true
        // };

        // vm.setProfilePanel = function (index) {
        //     vm.currentProfilePanelIndex = index;
        //     vm.isProfileEditorVisible = true;
        // }

        // $rootScope.$on('toggleProfileEditor', function () {
        //     vm.isProfileEditorVisible = !vm.isProfileEditorVisible;
        // });

        // vm.toggleProfileEditor = function () {
        //     $rootScope.$broadcast('toggleProfileEditor');
        // }
    }

    entityDashboardController.$inject = ['$scope', '$log', '$timeout', '$rootScope', '$location', '$uibModal',
        'sessionData', 'myProfile', 'dashboardFeatures', 'dashboardActivities', 'mostRecentItems',
        'mostRecentItemsThumbnails', 'milestones', 'myProfileDataService',
        'notifyService', 'milestoneModalService',
        'scrollingService', 'mailRequestDataService', 'entityProfilePercentageCompleteCalculatorService',
        '$pbService', 'STATES_LIST'];

    angular.module('ecap.dashboards').controller('entityDashboardController', entityDashboardController);
})();
